import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap5';
import ModalWithText from 'components/new_ui/WaitLayers/ModalWithText';

import { Link, useNavigate } from 'react-router-dom';
import routes from 'app/routes';
import Alert from 'components/new_ui/Alerts/alert';
import { useContext } from '../../Context';

export default function Footer({ members, removeMembersAfterImport }) {
  const { dispatch, actions, state } = useContext();
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);

  const onImport = () => {
    setLoader(true);
    actions.manualImport(dispatch, state.enterpriseId, members, (data) => {
      const status = removeMembersAfterImport(data);

      const membersWithEmails = members.map((item) => {
        const record = data.find((dataItem) => dataItem.email === item.email || item.email === dataItem.raw_email);

        return {
          ...item,
          email: record ? record.email : item.email,
        };
      });

      setLoader(false);
      if (status) {
        navigate(routes.managers.members.success, { state: { members: membersWithEmails } });
      } else {
        Alert({
          title: 'Import Members',
          text: 'Looks like some of the members on the list have errors. Please, fix them and try again.',
          confirmButtonText: 'Close',
        });
      }
    });
  };

  return (
    <>
      <footer>
        <Link
          to={routes.managers.members.index}
          className="btn btn-outline-primary"
        >
          Cancel
        </Link>

        <Button
          className={members.length === 0 ? 'disabled' : ''}
          onClick={onImport}
        >
          Import
        </Button>
      </footer>

      <ModalWithText show={loader} text="Please, wait. We are processing your data..." />
    </>
  );
}

Footer.propTypes = {
  removeMembersAfterImport: PropTypes.func.isRequired,
  members: PropTypes.arrayOf(PropTypes.object),
};

Footer.defaultProps = {
  members: null,
};
